import { render, staticRenderFns } from "./GameCountdown.vue?vue&type=template&id=c2f656ec&scoped=true&"
import script from "./GameCountdown.vue?vue&type=script&lang=js&"
export * from "./GameCountdown.vue?vue&type=script&lang=js&"
import style0 from "./GameCountdown.vue?vue&type=style&index=0&id=c2f656ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f656ec",
  null
  
)

export default component.exports